module.exports = __webpack_public_path__ + "static/drzhanna-website-logo-df0119ee41cbf7fbba75e003c53cb360.jpg";